module.exports = __webpack_public_path__ + "img/portoferreira.f1e6814c.png";